// src/Components/PrivateRoute/PrivateRoute.js
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getToken, isTokenValid, isPathAllowed, IsAuthenticated, getTokenIssuer } from "../../Utils/JWTTokenUtil";

const PrivateRoute = ({ element: Component }) => {
  const loc = useLocation();
  if (getTokenIssuer() !== "ITaaP" && !IsAuthenticated()) {
    return <Navigate to="/" replace />;
  } else if (getTokenIssuer() === "ITaaP") {
    const token = getToken();
    if (!isTokenValid(token)) return <Navigate to="/" replace />
  }

  // Role-based guard for the current path
  if (!isPathAllowed(loc.pathname)) {
    // Bounce to a safe page where the user will only see allowed items
    return <Navigate to="/home" replace />;
  }

  return Component;
};

export default PrivateRoute;
